import { TQueryParameters } from '../../repositories/developer-card/v1/search-developers';
import { IFilters } from '../../types/filters';

export function getFiltersFromQueryParams(params: Record<string, string>): IFilters {
  let location: number | undefined;

  if (params.location) {
    // Извлекаем locationId из параметра location
    const value = Number(params.location);

    if (!isNaN(value)) {
      location = value;
    }
  } else {
    // Извлекаем первый location из параметров вида location[0]=1&location[1]=2
    for (const key of Object.keys(params)) {
      const locationMatch = key.match(/^location\[(\d+)\]$/);

      if (locationMatch) {
        const value = Number(params[key]);

        if (!isNaN(value)) {
          location = value;
          break;
        }
      }
    }
  }

  return {
    page: Number(params.p) || undefined,
    location,
    searchText: params.search_text,
    sort: params.sort as TQueryParameters,
  };
}
